'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Input } from '../input/input.js';

/**
 * SearchInput component, used to display a search input within the Search component.
 *
 * @example
 * <Search>
 *   <SearchInput aria-label='Søk' />
 * </Search>
 */
const SearchInput = forwardRef(function SearchInput({ ...rest }, ref) {
    return (jsx(Input, { ref: ref, type: 'search', 
        /* We need an empty placeholder for the clear button to be able to show/hide */
        placeholder: '', ...rest }));
});

export { SearchInput };
